import { connect } from 'react-redux'
import {
  selectCcVisible,
  selectBccVisible,
  selectSubjectVisible,
  selectLastVisible,
} from 'selectors/reply_form'
import { selectIsEditorFocused } from 'ducks/editor'

import Expanded from './view'

const select = state => {
  return {
    ccVisible: selectCcVisible(state),
    bccVisible: selectBccVisible(state),
    subjectVisible: selectSubjectVisible(state),
    focusField: selectLastVisible(state),
    isEditorFocused: selectIsEditorFocused(state),
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  }
}

export default connect(select, null, mergeProps)(Expanded)
